export const themeConfigProvider = {
  token: {
    fontFamily: 'Roboto, sans-serif',
    borderRadius: 0,
    colorTextDescription: '#8C8C8C',
  },
};

export const themeColors = {
  character: {
    title85: 'rgba(0, 0, 0, 0.85)',
    title25: 'rgba(0, 0, 0, 0.25)',
    primary85: 'rgba(0, 0, 0, 0.85)',
  }
}
